"use client";

import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";

import { Post } from "@/shared/libs/axios/request";
import { itemKeys } from "@/entities/item";
import type { CreateItemRequest, ItemResponse } from "@stocks/shared";

export const useCreateItem = () => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (values: CreateItemRequest) =>
      Post<ItemResponse, CreateItemRequest>("/v1/items", values),
    onSuccess: (res) => {
      qc.invalidateQueries({ queryKey: itemKeys.all });
      toast.success(res.data.message);
    },
    onError: (error) =>
      toast.error(error.response?.data.message ?? "품목 등록에 실패했습니다."),
  });
};
